import { z } from "zod";
import { Percentage1or2DecimalsRegex } from "../../constants/regex/regex";
import { AltAssetId, ClientId, ExternalAccountId, FartherAccountId, VirtualAccountId, } from "../Types";
import { GoalBasedFinancialPlanDateIdSchema } from "./ids";
export const GoalBasedPlanDateTypes = [
    "Age",
    "AlreadyStarted",
    "Year",
    "DateString",
];
export const GoalBasedPlanDateTypeSchema = z.enum(GoalBasedPlanDateTypes);
export const GoalBasedPlanDateLabels = [
    "Age",
    "Already Started",
    "Year",
    "Date String",
];
export const GoalBasedPlanDateLabelSchema = z.enum(GoalBasedPlanDateLabels);
export const GoalBasedPlanDateTypeMap = {
    Age: "Age",
    AlreadyStarted: "Already Started",
    Year: "Year",
    DateString: "Date String",
};
export const GoalBasedRepeatTimeFrames = [
    "None",
    "EveryMonth",
    "EveryYear",
    "Every2Years",
    "Every3Years",
    "Every4Years",
    "Every5Years",
    "Every6Years",
    "Every7Years",
    "Every8Years",
    "Every9Years",
    "Every10Years",
];
export const GoalBasedRepeatTimeFrameSchema = z.enum(GoalBasedRepeatTimeFrames);
export const GoalBasedRepeatTimeFrameLabelSchema = z.enum([
    "None",
    "Every Month",
    "Every Year",
    "Every 2 Years",
    "Every 3 Years",
    "Every 4 Years",
    "Every 5 Years",
    "Every 6 Years",
    "Every 7 Years",
    "Every 8 Years",
    "Every 9 Years",
    "Every 10 Years",
]);
export const GoalBasedGoalRepeatsMap = {
    None: "None",
    EveryMonth: "Every Month",
    EveryYear: "Every Year",
    Every2Years: "Every 2 Years",
    Every3Years: "Every 3 Years",
    Every4Years: "Every 4 Years",
    Every5Years: "Every 5 Years",
    Every6Years: "Every 6 Years",
    Every7Years: "Every 7 Years",
    Every8Years: "Every 8 Years",
    Every9Years: "Every 9 Years",
    Every10Years: "Every 10 Years",
};
export const GoalBasedPlanDateRequest = z.object({
    owner: ClientId,
    planDateId: GoalBasedFinancialPlanDateIdSchema.optional(),
    value: z.string(),
    dateType: GoalBasedPlanDateTypeSchema,
});
export const GoalBasedPlanDateResponse = z.object({
    owner: ClientId,
    planDateId: GoalBasedFinancialPlanDateIdSchema,
    value: z.string(),
    dateType: GoalBasedPlanDateTypeSchema,
});
export const AnnualIncreaseTypes = [
    "None",
    "GeneralInflation",
    "CustomInflation",
];
export const AnnualIncreaseTypeSchema = z.enum(AnnualIncreaseTypes);
export const AnnualIncreaseLabels = [
    "None",
    "General Inflation",
    "Custom Inflation",
];
export const AnnualIncreaseTypeLabelSchema = z.enum(AnnualIncreaseLabels);
export const GoalBasedFinancialPlanAnnualIncreaseInputSchema = z.discriminatedUnion("type", [
    z.object({
        type: z.literal(AnnualIncreaseTypeSchema.Enum.None),
    }),
    z.object({
        type: z.literal(AnnualIncreaseTypeSchema.Enum.GeneralInflation),
    }),
    z.object({
        type: z.literal(AnnualIncreaseTypeSchema.Enum.CustomInflation),
        value: z
            .string()
            .refine((p) => Percentage1or2DecimalsRegex.test(p), {
            message: "annualIncrease value is not formatted correctly; it can only contain 1 or 2 decimals",
        })
            .refine((p) => parseFloat(p) > 0 && parseFloat(p) <= 100, {
            message: "annualIncrease value must be greater than 0 and less than or equal to 100",
        }),
    }),
]);
export const GoalBasedFinancialPlanAnnualIncreaseResponseSchema = GoalBasedFinancialPlanAnnualIncreaseInputSchema.optional();
export const GoalBasedFinancialPlanAssetLiabilityId = z.union([
    FartherAccountId,
    VirtualAccountId,
    AltAssetId,
    ExternalAccountId,
]);
//# sourceMappingURL=types.js.map